/**
 * Utilitários para formatação de campos
 */

/**
 * Remove todos os caracteres não numéricos de uma string
 */
export function removeNonNumeric(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * Formata CNPJ: 00.000.000/0000-00
 */
export function formatCNPJ(value: string): string {
  const numbers = removeNonNumeric(value);
  if (numbers.length <= 2) return numbers;
  if (numbers.length <= 5) return `${numbers.slice(0, 2)}.${numbers.slice(2)}`;
  if (numbers.length <= 8) return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5)}`;
  if (numbers.length <= 12) return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8)}`;
  return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8, 12)}-${numbers.slice(12, 14)}`;
}

/**
 * Formata CPF: 000.000.000-00
 */
export function formatCPF(value: string): string {
  const numbers = removeNonNumeric(value);
  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 6) return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
  if (numbers.length <= 9) return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`;
  return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`;
}

/**
 * Formata dinamicamente como CPF ou CNPJ dependendo do tamanho (até 11 é CPF, dps é CNPJ)
 */
export function formatCpfCnpj(value: string): string {
  const numbers = removeNonNumeric(value);
  if (numbers.length <= 11) {
    return formatCPF(numbers);
  } else {
    // Para CNPJ, queremos reformatar limitando a no máximo 14 dígitos numéricos
    return formatCNPJ(numbers.slice(0, 14));
  }
}

/**
 * Formata CEP: 00000-000
 */
export function formatCEP(value: string): string {
  const numbers = removeNonNumeric(value);
  if (numbers.length <= 5) return numbers;
  return `${numbers.slice(0, 5)}-${numbers.slice(5, 8)}`;
}

/**
 * Formata Telefone: (00) 00000-0000 ou (00) 0000-0000
 */
export function formatTelefone(value: string): string {
  const numbers = removeNonNumeric(value);
  if (numbers.length <= 2) return numbers;
  if (numbers.length <= 6) return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
  if (numbers.length <= 10) {
    // Telefone fixo: (00) 0000-0000
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
  }
  // Celular: (00) 00000-0000
  return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
}

/**
 * Limpa formatação e retorna apenas números
 */
export function cleanCNPJ(value: string): string {
  return removeNonNumeric(value);
}

export function cleanCPF(value: string): string {
  return removeNonNumeric(value);
}

export function cleanCEP(value: string): string {
  return removeNonNumeric(value);
}

export function cleanTelefone(value: string): string {
  return removeNonNumeric(value);
}

/**
 * Formata Validade do Cartão: MM/AA
 */
export function formatValidade(value: string): string {
  const numbers = removeNonNumeric(value);
  // Limitar a 4 dígitos (MMAA)
  const limited = numbers.slice(0, 4);
  if (limited.length <= 2) return limited;
  return `${limited.slice(0, 2)}/${limited.slice(2, 4)}`;
}
